module.exports = __webpack_public_path__ + "static/img/200218.18464924.png";